import { Transition } from "@headlessui/react";
import { FormikErrors, FormikProps } from "formik";
import React, { Fragment, useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import PrescriptionScheduler from "./PrescriptionScheduler";

interface props {
  label: string;
  id: string;
  name: string;
  values: number[] | string[] | { name: string; id: any }[];
  add: (value: { name: string; prescriptionId: any }) => void;
  remove: (value: { name: string; prescriptionId: any }) => void;
  loading: boolean;
  errorMsg?: string | string[] | FormikErrors<any>[];
  query: (query: string) => void;
  list: { name: string; prescriptionId: any }[];
  formik: FormikProps<any>;
}

const PrescriptionAsyncMultiSelect = ({
  id,
  label,
  name,
  values,
  add,
  remove,
  loading,
  errorMsg,
  query,
  list,
  formik,
}: props) => {
  const inputRef = useRef<HTMLInputElement>();
  const [show, setshow] = useState(false);

  const handleSearchDebounce = React.useCallback(
    (q) => {
      if (q) {
        query(q);
        openModal();
      }
    },
    [inputRef?.current?.value]
  );

  function openModal() {
    setshow(true);
  }

  function closeModal() {
    setshow(false);
  }

  function addValue(x: { name: string; prescriptionId: any }) {
    if (x) {
      const index = values.findIndex(
        (pres) => pres.prescriptionId === x.prescriptionId
      );
      if (index < 0) {
        add(x);
        inputRef.current.value = "";
      }
    }
    closeModal();
  }

  function removeValue(x: { name: string; prescriptionId: any }) {
    remove(x);
  }

  return (
    <>
      {show && (
        <button
          onClick={closeModal}
          type="button"
          className="bg-transparent fixed w-screen h-screen"
        />
      )}
      <div className="flex flex-col gap-3">
        <div className="relative flex flex-col w-full gap-3">
          {/* <label htmlFor={id}>{label}</label> */}
          <div className="relative flex flex-col">
            <input
              ref={inputRef}
              id={id}
              name={name}
              onFocus={() => setshow(true)}
              type="search"
              className="bg-blue bg-opacity-10 px-4 w-full h-14"
              onChange={(e) => handleSearchDebounce(e.target.value)}
              placeholder={label}
            />
            {typeof errorMsg === "string" && (
              <small className="text-red-500 mt-1">{errorMsg}</small>
            )}
          </div>
          <>
            {show && (
              <Transition
                as={Fragment}
                show={true}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <div
                  id={"yourDropdownContainer"}
                  className="absolute top-14 w-[95%] max-h-[21rem] overflow-x-auto flex bg-white shadow-xl border rounded-md mx-2 py-2 z-10"
                >
                  {loading ? (
                    <span className="px-2 text-black">Loading...</span>
                  ) : (
                    <span className="text-black flex flex-col w-full">
                      {list &&
                        list.length > 0 &&
                        list.map((x, i) => (
                          <button
                            key={i}
                            type="button"
                            onClick={() =>
                              addValue({
                                name: x.name,
                                prescriptionId: x.prescriptionId,
                              })
                            }
                            className="bg-gray-100 hover:bg-gray-300 focus:bg-gray-300 w-full text-left p-2"
                          >
                            {x.name}
                          </button>
                        ))}
                    </span>
                  )}
                </div>
              </Transition>
            )}
          </>
        </div>
        {Array.isArray(values) && values.length > 0 && (
          <div className="flex flex-wrap gap-2 text-black">
            {values.map((x, i) => (
              <PrescriptionScheduler
                key={i}
                data={x}
                formik={formik}
                removeValue={removeValue}
                index={i}
              />
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default PrescriptionAsyncMultiSelect;
